export enum VidswapType {
  Game = 'game',
  Practice = 'practice',
}

export const VidswapTypes = [
  {value: VidswapType.Game, displayValue: 'Game'},
  {value: VidswapType.Practice, displayValue: 'Practice'}
]